<template>
  <div class="referral">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('list.showReferral') }}
        </h3>
      </div>
      <div class="box-body">
        <form-referral :editable="false" />
      </div>
    </div>
  </div>
</template>

<script>
import FormReferral from './Form'
export default {
  name: 'Show',
  components: { FormReferral },
  metaInfo () {
    return {
      title: this.$t('string.showReferral'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped>

</style>
